import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './reality-check.magic.css.js';
import script from './reality-check.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reality-check",attrs:{"part":"reality-check","data-v-test-id":"reality-check"}},[(!_vm.options.length > 0)?_c('magic-ui-loader'):_c('form',{staticClass:"form",attrs:{"part":"form"}},[_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","data-v-test-id":"reality-check-description","content":_vm.$t('reality-check.description')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h3","part":"title","content":_vm.$t('reality-check.title')}}),_vm._v(" "),_c('magic-ui-radio-group',{staticClass:"radio-group",attrs:{"column":"","part":"radio-group","data-v-test-id":"reality-check-radio-group","value":(_vm.duration)},on:{"change":function($event){_vm.duration=$event.detail[0];}}},[(!_vm.removeNoneOption)?_c('magic-ui-radio',{staticClass:"radio",attrs:{"id":"none","value":"0","part":"radio","disabled":_vm.disableOptions},domProps:{"innerHTML":_vm._s(_vm.$t("reality-check.none.label"))}}):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(value){return _c('magic-ui-radio',{key:value,staticClass:"radio",attrs:{"part":"radio","id":value,"value":value,"disabled":_vm.disableOptions},domProps:{"innerHTML":_vm._s(_vm.$t(("reality-check." + value + "-minutes.label")))}})})],2),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-button',{attrs:{"wide":"","variant":"primary","data-v-test-id":"reality-check-submit","disabled":_vm.disableOptions,"loading":_vm.isSubmitting},domProps:{"innerHTML":_vm._s(_vm.$t('reality-check.button'))},on:{"click":function($event){return _vm.saveRealityCheck()}}})],1)],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-690c7b65_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-690c7b65";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
